import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=67fbfa7b&scoped=true&lang=html&"
import script from "./DriverList.vue?vue&type=script&lang=js&"
export * from "./DriverList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fbfa7b",
  null
  
)

export default component.exports